@if (fullscreen) {
    <div class="loading-overlay" role="status" aria-live="polite">
        <div class="text-center">
            <div class="spinner-ring mx-auto" aria-hidden="true"></div>
            <p class="mt-3 mb-0 small text-muted">Cargando…</p>
        </div>
    </div>
} @else {
    <div class="loading-box" role="status" aria-live="polite" aria-busy="true">
        <span class="visually-hidden">Cargando…</span>
        <div class="skeleton skeleton--card" aria-hidden="true"></div>
        <div class="skeleton skeleton--card" aria-hidden="true"></div>
        <div class="skeleton skeleton--card" aria-hidden="true"></div>
    </div>
}
